import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestModel } from '@apps-common/types/portal/service-request'

type UnitActivationActionOptions = 'now' | 'power-up'

const getActionPath = (action: string) => {
  if (action === 'now') {
    return 'unitactivationnow'
  }

  if (action === 'power-up') {
    return 'unitactivationonpowerup'
  }

  return ''
}

export const actionUnitActivation = async (
  model: IActivationServiceRequestModel,
  action: string
): Promise<IActivationServiceRequestModel> => axios.post(`/UnitActivation/${getActionPath(action)}`, model).then((res) => res?.data?.data)

type Props = {
  model: IActivationServiceRequestModel
  action: string
}

export const useActionUnitActivation = (
  notify?: boolean,
  onSuccess?: (data: IActivationServiceRequestModel) => void,
  onError?: (variables: Props) => void
) =>
  useMutation({
    mutationKey: ['actionUnitActivation'],
    mutationFn: ({ model, action }: Props) => actionUnitActivation(model, action),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Request sent.')
      }
    },
    onError: (error, variables) => {
      if (onError) {
        onError(variables)
      }
      if (notify) {
        toastError(error?.message || 'Failed to send request, please try again.')
      }
    },
    throwOnError: false
  })
